import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import { Star } from 'lucide-react';
import { Users } from 'lucide-react';
const MetaWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const RatingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
  
  .star-icon {
    fill: #facc15;
    color: #facc15;
    width: 16px;
    height: 16px;
  }
`;
const RatingValue = styled.span`
  font-weight: 600;
  color: #1f2937;
`;
const ReviewCount = styled.span`
  color: #6b7280;
  font-size: 0.875rem;
`;
const EnrollmentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #6b7280;
  font-size: 0.875rem;
`;
export const CourseHeaderMeta = ({ rating, reviewCount, enrollmentCount, onReviewsClick })=>{
    // 데이터 포맷팅
    const displayRating = rating ? rating.toFixed(1) : '0.0';
    const displayReviewCount = reviewCount !== null && reviewCount !== undefined ? reviewCount : 0;
    const displayEnrollmentCount = enrollmentCount || '0';
    return /*#__PURE__*/ _jsxs(MetaWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(RatingWrapper, {
                onClick: onReviewsClick,
                title: "리뷰 보러가기",
                children: [
                    /*#__PURE__*/ _jsx(Star, {
                        className: "star-icon"
                    }),
                    /*#__PURE__*/ _jsx(RatingValue, {
                        children: displayRating
                    }),
                    /*#__PURE__*/ _jsxs(ReviewCount, {
                        children: [
                            "(",
                            displayReviewCount,
                            " ratings)"
                        ]
                    })
                ]
            }),
            enrollmentCount && /*#__PURE__*/ _jsxs(EnrollmentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Users, {
                        size: 14
                    }),
                    displayEnrollmentCount,
                    " students"
                ]
            })
        ]
    });
};
